import { render, staticRenderFns } from "./StockControlList.vue?vue&type=template&id=0b6566fc&"
import script from "./StockControlList.vue?vue&type=script&lang=js&"
export * from "./StockControlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports